import actions from './actions';
import mutations from './mutations.js';
import getters from './getters.js';

const state = {
    intervalsSettings: {
        saved: false,
        intervals: null
    },
    currency: '',
    date: '',
    selected: []
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters,
}